import React, { Component } from 'react'
import Iframe from 'react-iframe'


export default class Discography extends Component {
    render() {
        return (
            <div>

<div class='discography'>
            
            <h4>DISCOGRAPHY:</h4>
            <h5>Jennifer Lo-Fi : 2009 - 2013</h5>
            <div className='albumsDiv'>
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=3589222276/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://jenniferlofi.bandcamp.com/album/j-lo-fi-ep">
                    J Lo-Fi EP by Jennifer Lo-Fi</a>
                </Iframe>
            
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=1040181023/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://jenniferlofi.bandcamp.com/album/summer-session">
                    Summer Session by Jennifer Lo-Fi</a>
                </Iframe>
    
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=3490597356/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://jenniferlofi.bandcamp.com/album/noia">
                    Noia by Jennifer Lo-Fi</a>
                </Iframe>
        
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=960507982/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://jenniferlofi.bandcamp.com/album/parto">
                    Parto by Jennifer Lo-Fi</a>    
                </Iframe>
            </div>
    
        <h5>Ema Stoned: 2011 - 2016</h5>
        <div className='albumsDiv'>
    
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=3577916688/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://emastoned.bandcamp.com/album/gema">
                    Gema by Ema Stoned</a>                      
                </Iframe>

                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=1844413375/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://emastoned.bandcamp.com/album/live-from-aurora">
                    Live from Aurora by Ema Stoned</a>                  
                </Iframe>
        </div>
    
        <h5>Mawn: 2014 - present</h5>
        <div className='albumsDiv'>
    
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=3942767518/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://mawn.bandcamp.com/album/um">
                    Um by Mawn</a> 
                </Iframe>
    
                <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                   src="https://bandcamp.com/EmbeddedPlayer/album=1702514394/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                   <a href="https://mawn.bandcamp.com/album/dois">
                    Dois by Mawn</a>
                </Iframe>
        </div>        
    
        <h5>Sabine Holler: 2017 - present </h5>
        <div className='albumsDiv'>
                 <Iframe
                    className='bandcamp'
                    borderStyle= 'none'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=1166185401/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://sabineholler.bandcamp.com/album/mother-of-transition">
                    Mother of Transition by Sabine Holler</a>
                 
                </Iframe>   
                </div>
              
                
        <h5>Barrie: 2018 - 2019</h5>
    
        <div className='albumsDiv'>
                    <Iframe
                    className='bandcamp'
                    border= 'transparent'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=2586957328/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/"
                    seamless>
                    <a href="https://barrie.bandcamp.com/album/happy-to-be-here">
                    Happy To Be Here by Barrie</a>
                    </Iframe>
                </div>
        
        <h5>Psymon Spine: 2019 - present</h5>

        <div className='albumsDiv'>
                    <Iframe
                    className='bandcamp'
                    border= 'transparent'
                    width = '175px'
                    height= '235px'
                    src="https://bandcamp.com/EmbeddedPlayer/album=3405422813/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless>
                    <a href="https://psymonspine.bandcamp.com/album/charismatic-megafauna">
                    Charismatic Megafauna by PSYMON SPINE</a>
                    </Iframe>
                </div>
</div>
        
    
</div>
        )
    }
}
